import type { ReactNode } from 'react';
import { Label } from '@/components/atoms';
import { cn } from '@/lib/utils';
import { InfoTip } from '../info-tip';

export interface FormFieldProps {
  label: string;
  htmlFor?: string;
  className?: string;
  error?: string;
  infoTip?: string;
  required?: boolean;
  children: ReactNode;
}

export const FormField = ({
  label,
  htmlFor,
  children,
  className,
  error,
  infoTip,
  required = false,
}: FormFieldProps) => {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      <Label htmlFor={htmlFor}>
        {label}
        {required && <span className="text-destructive ml-0.5">*</span>}
        {infoTip && (
          <InfoTip
            content={infoTip}
            ariaLabel={`More information about ${label}`}
          />
        )}
      </Label>
      {children}
      <span className="text-destructive text-xs">{error}</span>
    </div>
  );
};
